import axios from "axios";
const configs = require("./configs");

export default async function getHelper(url) {
  const { xApiKey } = await configs;
  const req = await axios.get(url, {
    headers: {
      "x-api-key": xApiKey,
    },
  });
  return req.data;
}
